import { useEffect } from "react";
import { hasWindow } from "@litres/utils";
import {
  api,
  rtkqApi,
  useAppDispatch,
  useAppSelector,
} from "@litres-core/store";

// Хук синхронизирует куки анонима между соседними открытыми вкладками
export const useSyncAnonCookies = () => {
  const dispatch = useAppDispatch();
  const isAnon = useAppSelector(state => !state.foundationUser.id);

  const onCookiesUpdate = ({ cookie, oldCookie }: TCookieChangeCallback) => {
    const basketCookie = getCookieValueFromString("BSK", cookie) || "";
    const oldBasketCookie = getCookieValueFromString("BSK", oldCookie) || "";
    const wishlistCookie = getCookieValueFromString("LKS", cookie) || "";
    const oldWishlistCookie = getCookieValueFromString("LKS", oldCookie) || "";
    if (
      basketCookie !== oldBasketCookie ||
      wishlistCookie !== oldWishlistCookie
    ) {
      // Устанавливаем значения кук в стор
      dispatch(
        api.foundationUser.setCustomCookieValue({
          BSK: basketCookie.split(","),
          LKS: wishlistCookie.split(","),
        })
      );
      // Устанавливаем значения кук в заголовки для запросов
      dispatch(api.browser.setHeader(["Basket", basketCookie]));
      dispatch(api.browser.setHeader(["Wishlist", wishlistCookie]));

      if (basketCookie !== oldBasketCookie) {
        dispatch(rtkqApi.util?.invalidateTags(["Cart", "Offer"]));
      }
    }
  };

  useEffect(() => {
    let interval: NodeJS.Timeout | undefined;
    if (isAnon) {
      interval = listenCookieChange(onCookiesUpdate);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isAnon]);
};

export interface TCookieChangeCallback {
  oldCookie: string;
  cookie: string;
}
export function listenCookieChange(
  callback: (v: TCookieChangeCallback) => void,
  interval = 1000
) {
  if (!hasWindow) {
    return;
  }
  let lastCookie = document.cookie;
  return setInterval(() => {
    const cookie = document.cookie;
    if (cookie !== lastCookie) {
      try {
        callback({ oldCookie: lastCookie, cookie: cookie });
      } finally {
        lastCookie = cookie;
      }
    }
  }, interval);
}

export function getCookieValueFromString(name: string, str: string) {
  const cookieName = name + "=";
  const decodedCookie = decodeURIComponent(str);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(cookieName) == 0) {
      return c.substring(cookieName.length, c.length);
    }
  }
  return undefined;
}
